var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAboutUsVector = function SvgAboutUsVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 660,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6A0000",
    d: "M631.33.179H325v4.226h312.02c15.16 0 22.2-2.837 22.2 11.595v-.648C659.22-2.776 646.73.18 631.33.18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A0000",
    d: "M27.89.179h297.33v4.226H22.2C7.04 4.405 0 1.568 0 16v-.648C0-2.776 12.49.18 27.89.18"
  })));
};
export default SvgAboutUsVector;